module.exports = __webpack_public_path__ + "img/d20190322_2.87f27996.jpg";